<template>
  <div>
    <b-card no-body class="text-light text-center" header-tag="header">
      <template v-slot:header>{{strings["selected.satellite"]}}</template>
      <b-table-simple
        class="table-dark table-sm text-light"
        outlined
        bordered
        v-if="satName"
      >
        <b-tbody class="text-left">
          <b-tr>
            <b-td>{{strings["name"]}}:</b-td>
            <b-td>{{satName}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["satellite.catalog.number"]}}:</b-td>
            <b-td>{{id}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["satellite.international.designation"]}}:</b-td>
            <b-td>{{cospar}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["orbit"]}}:</b-td>
            <b-td>{{orbit}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["Range"]}}:</b-td>
            <b-td>{{topoPos ? topoPos.distance : null}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["altitude"]}}:</b-td>
            <b-td>{{topoPos ? topoPos.altitude + '°': null}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["Azimuth"]}}:</b-td>
            <b-td>{{topoPos ? topoPos.azimuth + '°': null}}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{strings["Magnitude"]}}:</b-td>
            <b-td>{{mag}}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div v-if="!satName" class="text-left selectHelp">
         {{strings["sat.select.options"]}}<br />
         <ul><li>{{strings["click.on.list.item"]}}</li>
         <li>{{strings["click.near.sat.in.chart"]}}</li>
         </ul>
      </div>
    </b-card>
  </div>
</template>
<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import numeral from "numeral";
import { mapState } from "vuex";
import * as HA from "@h-a/astrolib";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  name: "SatellitePopup",
  props: {
    satData: null
  },
  computed: {
    ...mapState(["utc", "location", "culture", "strings"]),
    //...mapGetters(["utc", "location"]),
    satName: function() {
      return this.satData ? this.satData.sat.name : null;
    },
    id: function() {
      return this.satData ? this.satData.sat.id : null;
    },
    cospar: function() {
      if (this.satData) {
        let orbit = this.satData.sat.orbit;
        let y = parseInt(orbit.tle.substr(9, 2));
        if (y >= 57) y += 1900;
        else y += 2000;
        let loy = orbit.tle.substr(11, 3);
        let piece = orbit.tle.substr(14, 3);
        return y + "-" + loy + "-" + piece;
      }
      return null;
    },
    mag: function() {
      if (!this.satData) return null;
      return numeral(this.satData.mag).format("0,0.0");
    },
    orbit: function() {
      if (this.satData) {
        let orbit = this.satData.sat.orbit;
        return (
          numeral(orbit.perigeeHeight).format("0,0") +
          " x " +
          numeral(orbit.apogeeHeight).format("0,0") +
          " " +
          this.strings["km"] +
          "; " +
          numeral(orbit.inclination).format("0,0.0") +
          "°"
        );
      }
      return null;
    },
    topoPos: function() {
      if (!this.satData) return null;

      let topoPos = this.satData.topoPos;
      let az = 90 - topoPos.longitude * HA.RADTODEG;
      if (az < 0) az += 360;
      return {
        distance:
          numeral(topoPos.magnitude).format(0, 0) + " " + this.strings["km"],
        azimuth: numeral(az).format("0,0.0"),
        altitude: numeral(topoPos.latitude * HA.RADTODEG).format("0,0.0")
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .selectHelp {
    padding: 5px;
  }
</style>
